/**
 * Mirrors staff/student sign-in localStorage keys used by the student portal (Login.js + Members/SignIn).
 * @param {object} d API response body from CreateStudentPortalSessionResponse / Members/SignIn (student).
 * @returns {boolean}
 */
export function applyStudentPortalSessionFromResponse(d) {
  if (!d || d.status_code !== 1) return false;
  localStorage.setItem("AccessKey", d.AccessKey);
  localStorage.setItem("ID", d.ID);
  localStorage.setItem("FullName", d.FullName);
  localStorage.setItem("UserName", d.UserName);
  localStorage.setItem("User_Group_ID", d.User_Group_ID);
  localStorage.setItem("Group_Name", d.Group_Name);
  localStorage.setItem("DefaultSession", d.DefaultSessionID);
  localStorage.setItem("DefaultSessionName", d.DefaultSession);
  localStorage.setItem("DefaultFYear", String(d.DefaultFYear));
  localStorage.setItem("theme", "theme-light");
  localStorage.setItem("MemberType", d.MemberType);
  return true;
}

/** Common auth fields for student/parent portal API calls (UserID = selected student). */
export function getStudentPortalApiPayload(extra = {}) {
  const studentId = parseInt(localStorage.getItem("ID"), 10) || 0;
  const payload = {
    AccessKey: localStorage.getItem("AccessKey"),
    UserID: studentId,
    Student_ID: studentId,
    MemberType: localStorage.getItem("MemberType") || "Student",
    ...extra,
  };
  const parentProof = localStorage.getItem("ParentPortalProof");
  if (parentProof) {
    payload.ParentProof = parentProof;
  }
  return payload;
}
